import { PostHogProvider } from "posthog-js/react";
import React from "react";
import { posthogConfig } from "../frontendConfig";
import { AuthProvider } from "./auth";
import { UserProvider } from "./User";

const ContextProviders = ({ children }: { children: React.ReactNode }) => {
  const content = (
    <AuthProvider>
      <UserProvider>{children}</UserProvider>
    </AuthProvider>
  );

  return posthogConfig.enabled ? (
    <PostHogProvider apiKey={posthogConfig.apiKey} options={posthogConfig.options}>
      {content}
    </PostHogProvider>
  ) : (
    content
  );
};

export default ContextProviders;
